<vex-secondary-toolbar current="WYSIWYG Editor">
  <vex-breadcrumbs [crumbs]="['Apps', 'WYSIWYG Editor']"></vex-breadcrumbs>
</vex-secondary-toolbar>

<div class="p-gutter container">
  <div class="card">
    <quill-editor @fadeInUp
                  [formControl]="form"
                  [styles]="{ flex: '1 1 auto' }"></quill-editor>
  </div>
</div>
